export const cacheStoragePrefixAmaxPayPaymentDetails = 'requestOptions.xero.amaxPay.paymentDetails.';
